import styled from "@emotion/styled";

export const AccordionTableWrapper = styled.div`
  margin-top: ${p => p.theme.space[6]}px;
`;
